import { lazy, Suspense, useEffect, type ReactNode } from 'react';
import { Routes as AppRoutes, Route, useNavigate } from 'react-router-dom';
import { BuildTime } from '@pages/buildTimer/index.tsx';
import { MainRoutes } from '@pages/main/index.tsx';
import { MainRoutesPaths } from '@pages/paths.ts';
// import { SpecialistsPage } from '@pages/coaches/main/index';
import { ModalMessageCopy } from '@features/common';
import { useAuthToken, useCookies, usePlatformSettings } from '@shared/hooks/index.ts';
import { PhoneVerificationIncomingModal } from '@shared/ui/modals/phone-verification-incoming-modal/PhoneVerificationIncomingModal.tsx';
import { authService } from '@src/library/api/authService.ts';
import { Loader } from '@src/library/components/common/index';
import { Events, Notifications, PaymentListener, ProgramPayment, RootModal } from 'modules';
import { IS_DEV } from '../../config.ts';
import { Articles } from './articles';
// import { useModules } from '@src/entities/common';
import { Cart } from './cart';
// import { ProtectedRoute } from 'library/components/common';
import { Clients } from './clients';
import { CoachesRouts } from './coaches';
import { Consultations } from './consultations';
import { ContactsPage } from './contacts';
import { Messenger } from './messenger';
import { NotFound } from './not-found';
// import { NotePage } from './note';
import { Personal } from './personal';
import { Programs } from './programs';
import { Shop } from './shop';
import { Support } from './support';
import { TechService } from './tech-service';

const Schedules = lazy(() => import('@pages/shedules/index'));
const CommonPagesRoutes = lazy(() => import('@pages/common/index.tsx'));
const withSuspense = (component: ReactNode) => (
  <Suspense fallback={<Loader />}>{component}</Suspense>
);
export const Routes = () => {
  const navigate = useNavigate();
  const { removeCookie } = useCookies();
  const { setToken } = useAuthToken();
  const { is_demo } = usePlatformSettings();
  const isDemoUser = sessionStorage.getItem('demoUser');
  useEffect(() => {
    if (is_demo && !isDemoUser) {
      removeCookie('csrftoken');
      removeCookie('sessionid');
      authService
        .login({
          phonenumber: `+${'+79000000003'.replace(/\+/, '')}`,
          password: 'Govi1234',
        })
        .then((response) => {
          setToken(response.data.key);
          sessionStorage.setItem('demoUser', 'true');
          window.location.reload();
        });
    }
  }, [is_demo, isDemoUser, removeCookie, setToken]);

  if (window.location.href.indexOf('index.html') !== -1) navigate('/');

  return (
    <>
      <RootModal />

      <AppRoutes>
        {/* {logo_url ? <Redirect from="/" to={redirectTo()} /> : <Route path="/" component={Main} />} */}
        <Route path={`${MainRoutesPaths.main}*`} element={<MainRoutes />} />
        <Route path="technical-service" element={<TechService />} />
        <Route path="program-payment" element={<ProgramPayment />} />
        <Route path="messenger" element={<Messenger />} />

        {/* <Route path="/admin/:code" element={<AdminPanel />} />
				<Route path="/statistics/:code" element={<Statistics />} /> */}

        <Route path="/consultations/*" element={<Consultations />} />
        {/*<Route path="/coaches/*" element={<SpecialistsPage />} />*/}
        <Route path="/coaches/*" element={<CoachesRouts />} />
        <Route path={`${MainRoutesPaths.schedule}*`} element={withSuspense(<Schedules />)} />
        <Route path={`${MainRoutesPaths.clients}*`} element={<Clients />} />
        <Route path={`${MainRoutesPaths.events}*`} element={<Events />} />
        <Route path="/programs/*" element={<Programs />} />
        <Route path="/shop/*" element={<Shop />} />
        <Route path="/personal/*" element={<Personal />} />
        <Route path={`${MainRoutesPaths.articles}*`} element={<Articles />} />

        <Route path="/support" element={<Support />} />
        <Route path="/payment" element={<PaymentListener />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/cart/*" element={<Cart />} />

        <Route path="/contacts/*" element={<ContactsPage />} />
        <Route path="/common/*" element={withSuspense(<CommonPagesRoutes />)} />

        {/*<Route path="/specialization" element={<Specialization />} />*/}
        {/* <Route path="/note/*" element={<NotePage />} /> */}

        <Route path="*" element={<NotFound />} />
      </AppRoutes>
      <PhoneVerificationIncomingModal />
      <ModalMessageCopy />
      {!IS_DEV && <BuildTime />}
    </>
  );
};
